<template>
	<div class="field org-user-select">
		<label class="label">{{ label }}</label>
		<span v-if="subText" class="sub-text" v-text="subText" />
		<span v-if="showInfoText" :class="infoTextClass" v-text="infoText" />
		<div class="control">
			<multiselect
				track-by="id"
				:custom-label="fieldLabel"
				:options="users"
				:value="myValue"
				:searchable="true"
				:loading="isFetching"
				deselect-label="Press enter to clear"
				:disabled="disabled"
				@input="myBlur"
			/>
		</div>
		<user-card
			v-if="showUser && myValue"
			:user="myValue"
			:show-details="true"
			size="is-64x64"
			class="selected-user"
		/>
		<p v-if="showError" class="help is-danger">{{ error }}</p>

		<div
			v-if="myValue && myValue.status !== 'active' && shouldBeActive"
			class="message is-warning mt-2"
		>
			<div class="message-body">
				This user is not active, they won’t receive site tour requests,
				contact Sally for help.
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import fieldMixin from "@lab/utils/fieldMixin";
import UserCard from "@/components/AppUserCard";
import { sortBy } from "lodash";

export default {
	components: { Multiselect, UserCard },
	mixins: [fieldMixin],
	props: {
		label: {
			type: String,
			default: () => "User"
		},
		infoText: {
			type: String,
			default: () => null
		},
		infoTextTagType: {
			type: String,
			default: "is-info"
		},
		subText: {
			type: String,
			default: () => null
		},
		disabled: {
			type: Boolean,
			default: () => false
		},
		showUser: {
			type: Boolean,
			default: () => false
		},
		organisationId: {
			type: Number,
			required: true
		},
		shouldBeActive: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		myValue() {
			return this.users.find((o) => o.id === this.value);
		},
		isFetching() {
			return this.$store.getters.organisationUsersIsFetching;
		},
		showInfoText() {
			return this.infoText;
		},
		infoTextClass() {
			return "user-info-text tag " + this.infoTextTagType;
		},
		users() {
			return sortBy(this.$store.getters.organisationUsersList, [
				"firstname"
			]);
		}
	},
	created() {
		this.fetchUsers();
	},
	methods: {
		async fetchUsers() {
			await this.$store.dispatch("organisationUsersLoad", {
				organisationID: this.organisationId
			});
		},
		fieldLabel({ firstname, lastname, email }) {
			return `${firstname} ${lastname} - (${email})`;
		},
		myBlur(user) {
			const val = user ? user.id : null;
			this.blur(val);
		}
	}
};
</script>

<style lang="scss">
@import "~@/scss/settings";
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.org-user-select {
	ul.multiselect__content {
		margin-left: 0;
	}
}

span.sub-text {
	margin-bottom: 0.75rem;
	display: block;
}

span.user-info-text {
	margin-bottom: 0.5em;
	display: block;
}
.selected-user {
	border-radius: $radius-large;
	border: 1px solid #ccc;
	background-color: white;
	padding: 0.5em;
	margin-top: 0.5em;
}
</style>

<style lang="scss" scoped>
.org-user-select {
	margin-bottom: 2rem;
}
</style>
